import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

import { childrenShape } from '@bibliocommons/bc-prop-types';
import { truncate } from '@bibliocommons/utils-string';
import { GhostLink } from '@bibliocommons/base-links';

import './LinkedPill.scss';

export default function LinkedPill({ className, children, icon, ...props }) {
  // TODO: Figure out a better way to truncate children.
  const truncatedText = truncate(children, { desiredLength: 20 });
  return (
    <GhostLink {...props} dataKey="pill-link" className={cn('cp-linked-pill', className)} rounded size="small">
      {icon}
      {truncatedText}
    </GhostLink>
  );
}

LinkedPill.propTypes = {
  className: PropTypes.string,
  children: childrenShape.isRequired,
  href: PropTypes.string.isRequired,
  icon: PropTypes.node
};
